var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReminder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1507_3930",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 33,
    height: 33
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.000156403H32.66V32.6602H0V0.000156403Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1507_3930)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.3838 16.3325C31.3838 24.7782 24.7753 31.3867 16.3296 31.3867C7.88394 31.3867 1.27539 24.7782 1.27539 16.3325H6.37852C6.37852 19.1392 7.52672 21.6907 9.36378 23.5533C11.2265 25.3905 13.523 26.2836 16.3296 26.2836C21.9686 26.2836 26.2807 21.9713 26.2807 16.3325C26.2807 10.6935 21.9686 6.3814 16.3296 6.3814V1.27828C24.7753 1.27828 31.3838 7.88683 31.3838 16.3325Z",
    stroke: "#02243D",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8814 16.3312C18.8814 17.7404 17.739 18.8828 16.3299 18.8828C14.9207 18.8828 13.7783 17.7404 13.7783 16.3312C13.7783 14.9221 14.9207 13.7797 16.3299 13.7797C17.739 13.7797 18.8814 14.9221 18.8814 16.3312Z",
    stroke: "#24BCFD",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5259 14.5273L9.95117 9.95265",
    stroke: "#24BCFD",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.82812 16.332C3.82812 15.4602 3.91214 14.6123 4.07276 13.796",
    stroke: "#02243D",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.90332 9.32031C7.24825 7.29335 9.17474 5.70392 11.4676 4.76724",
    stroke: "#02243D",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "square",
    strokeDasharray: "101.68 101.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7939 4.07422C14.6103 3.9136 15.4581 3.82959 16.33 3.82959",
    stroke: "#02243D",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReminder);
export default __webpack_public_path__ + "static/media/reminder.7c84676168086ed06a7afe7ad33b4760.svg";
export { ForwardRef as ReactComponent };